import { render } from "./PrintAmountInWords.vue?vue&type=template&id=00c55c69&scoped=true"
import script from "./PrintAmountInWords.vue?vue&type=script&lang=js"
export * from "./PrintAmountInWords.vue?vue&type=script&lang=js"

import "./PrintAmountInWords.vue?vue&type=style&index=0&id=00c55c69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c55c69"]])

export default __exports__